export const FOREIGN_MAX_LENGTH = 15 as number;
export const FOREIGN_MIN_LENGTH = 3 as number;
export const BELGIAN_LENGTH = 12 as number;
export const CHECKDIGIT_NUMBER = 97 as number;
export const COUNTRY_SUBSTRING_LENGTH = 2 as number;
export const VAT_SPLIT_LENGTH = 2 as number;
